import { useContext } from "react";
import React from "react";
import { AuthContext } from "../Authorization/AuthContext";
import { ActionButton } from "./Buttons/ActionButton";
import { Tooltip } from "./Tooltip";

export const CopyEntityID = ({
  entityId,
  clipboard = navigator.clipboard,
  tooltipText,
  size = "small",
  variant = "default",
}: {
  entityId: string;
  clipboard?: Pick<Clipboard, "writeText">;
  tooltipText: string;
  size?: "xs" | "small" | "medium";
  variant?: "default" | "inverted";
}) => {
  const { admin } = useContext(AuthContext);

  if (!admin) {
    return null;
  }

  return (
    <Tooltip
      content={
        <ActionButton
          icon="copy"
          size={size}
          variant={variant}
          onPress={async () => {
            await clipboard.writeText(entityId);
          }}
          data-testid="copy-entity-id"
          aria-label="Copy entity ID"
        />
      }
      popoverContent={tooltipText}
      leftSpace={false}
    />
  );
};
